import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-service-icon',
  templateUrl: './service-icon.component.html',
  styleUrls: ['./service-icon.component.scss']
})
export class AppServiceIconComponent implements OnChanges {
  @Input() icon: string = '';
  @Input() customPath?: string;

  useCustom = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customPath) {
      this.useCustom = true;
    }
  }

  onError(): void {
    this.useCustom = false;
  }
}
